if (!customElements.get("gero-in-showroom-cta")) {
  customElements.define(
    "gero-in-showroom-cta",
    class GeroInShowroomCta extends HTMLElement {
      connectedCallback() {
        const statusesScript = this.querySelector("[data-showroom-statuses]");
        this.statuses = null == statusesScript ? {} : JSON.parse(statusesScript.textContent);
        document.addEventListener("variantChangeEnd", this.onVariantChangeEnd);
      }

      disconnectedCallback() {
        document.removeEventListener("variantChangeEnd", this.onVariantChangeEnd);
      }

      // variantChangeEnd also fires for option combinations without a variant, unlike PUB_SUB_EVENTS.variantChange
      onVariantChangeEnd = (event) => {
        const variantOptions = event.target;
        if (this.dataset.productHandle !== variantOptions?.dataset?.productHandle) {
          return;
        }
        this.dataset.status = this.statuses[variantOptions.currentVariant?.id] ?? "";
      };
    },
  );
}
